import InputField from './input-field/controller';

export default InputField;
